import React from "react";
import { NavLink } from "react-router-dom";

import profileImg from "../assets/profile.jpg"; // add your image here

import useScrollAnimation from "../components/useScrollAnimation";

// import reactImg from "../assets/tech/react.png";
// import nodeImg from "../assets/tech/node.png";
// import jsImg from "../assets/tech/js.png";
// import phpImg from "../assets/tech/php.png";
// import sqlImg from "../assets/tech/sql.png";
// import dockerImg from "../assets/tech/docker.png";
// import bootstrapImg from "../assets/tech/bootstrap.png";


// const techStack = [
//   { name: "React", img: reactImg },
//   { name: "Node.js", img: nodeImg },
//   { name: "JavaScript", img: jsImg },
//   { name: "PHP", img: phpImg },
//   { name: "SQL", img: sqlImg },
//   { name: "Docker", img: dockerImg },
//   { name: "Bootstrap", img: bootstrapImg },
// ];


const techStack = [
    {
        name: "React",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    },
    {
        name: "Node.js",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    },
    {
        name: "JavaScript",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    },
    {
        name: "PHP",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
    },
    {
        name: "WordPress",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-original.svg",
    },
    {
        name: "MySQL",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    },
    {
        name: "MongoDB",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    },
    {
        name: "Python",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    },
    {
        name: "Java",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
    },
    // {
    //     name: "Docker",
    //     img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    // },
    {
        name: "Bootstrap",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    },
];

const projects = [

    {
        title: "Task Manager – Django Web App",
        desc: "A full-stack task management app built with Django featuring user authentication, task CRUD, status tracking, and a recycle bin system for safe task recovery.",
        tech: ["Python", "Django", "Bootstrap", "JavaScript", "HTML", "CSS"],
        demo: "https://task-manager-django-dncm.onrender.com",
        github: "https://github.com/Dhanashree-Raut/Task-Manager-Django",
    },
    {
        title: "NovaWeb Solutions – Django Service Website",
        desc: "A modern service-based website built using Django with responsive UI, service pages, and a contact form that saves user inquiries to the database.",
        tech: ["Python", "Django", "Bootstrap", "JavaScript", "HTML", "CSS"],
        demo: "https://novaweb-solutions-django.onrender.com/",
        github: "https://github.com/Dhanashree-Raut/NovaWeb-Solutions-Django",
    },
    {
        title: "InfynieNews - React Based",
        desc: "A responsive React-based news application that fetches live data via APIs and allows users to browse news by categories with a clean and user-friendly interface.",
        tech: ["React", "News API", "Bootstrap"],
        demo: "https://news-application-infynienews.onrender.com",
        github: "https://github.com/Dhanashree-Raut/News-Application---InfynieNews",
    },
    {
        title: "TextTools - React Text Utility App",
        desc: "A React-based text utility application that enables users to modify and analyze text with features like case conversion, space cleanup, real-time statistics, and light/dark mode support.",
        tech: ["React", "JavaScript", "Bootstrap", "CSS"],
        demo: "https://texttoolkit-1-xjb5.onrender.com",
        github: "https://github.com/Dhanashree-Raut/TextToolkit",
    },


    // {
    //     title: "Todo List App (LocalStorage)",
    //     desc: "A minimal todo app with add/delete functionality and localStorage persistence for data retention across page refreshes.",
    //     tech: ["HTML", "CSS", "JavaScript", "LocalStorage"],
    //     github: "https://github.com/Dhanashree-Raut/To-Do-List",
    //     demo: "https://dhanashree-raut.github.io/To-Do-List/",
    // },
    // {
    //     title: "Todo List Web App (Flask & SQLite)",
    //     desc: "A backend-driven todo app built with Flask and SQLAlchemy supporting full CRUD operations with persistent SQLite storage and Jinja templating.",
    //     tech: ["Python", "Flask", "SQLAlchemy", "SQLite", "HTML", "CSS"],
    //     github: "https://github.com/Dhanashree-Raut/ToDo/tree/main",
    //     demo: "https://todo-1-9vc7.onrender.com",
    // },
    {
        title: "Spotify UI Clone",
        desc: "A pixel-perfect dark-themed Spotify UI clone built with pure HTML and CSS showcasing modern layout techniques and responsive design.",
        tech: ["HTML", "CSS"],
        github: "https://github.com/Dhanashree-Raut/Spotify-UI-Clone",
        demo: "https://dhanashree-raut.github.io/Spotify-UI-Clone/",
    },
    {
        title: "Instagram UI Clone",
        desc: "A responsive Instagram UI clone featuring stories, posts, and sidebar layout built using Flexbox and Grid with reusable components.",
        tech: ["HTML", "CSS"],
        github: "https://github.com/Dhanashree-Raut/Instagram-Ui-Clone",
        demo: "https://dhanashree-raut.github.io/Instagram-Ui-Clone/",
    },
    // {
    //     title: "Sudoku Solver using Python",
    //     desc: "A Python-based Sudoku solver that uses a backtracking algorithm to solve any valid 9x9 puzzle with row, column, and grid constraint validation.",
    //     tech: ["Python", "NumPy", "Backtracking Algorithm"],
    //     github: "https://github.com/Dhanashree-Raut/Sudoku-game",
    // },
    // {
    //     title: "SQL Query Runner in Java (JDBC)",
    //     desc: "A Java AWT desktop app that lets users execute SQL DML and DQL queries against an MS Access database via JDBC with dynamic result display.",
    //     tech: ["Java", "AWT", "JDBC", "SQL"],
    //     github: "https://github.com/Dhanashree-Raut/Projret-to-run-SQL-queries-in-JAVA",
    // },
];



export default function Home() {
    // const techRef = useScrollAnimation();
    const projectRef = useScrollAnimation();
    const expRef = useScrollAnimation();

    return (
        <div className="container mt-5 pt-5">

            {/* HERO SECTION */}
            <div className="row align-items-center mb-5 text-center text-md-start">

                {/* LEFT SIDE */}
                <div className="col-md-6 d-flex flex-column align-items-center">

                    <img
                        src={profileImg}
                        alt="Profile"
                        className="img-fluid rounded-circle shadow mb-3"
                        style={{
                            maxWidth: "200px",
                            width: "60%",
                            minWidth: "130px"
                        }}
                    />

                    <a
                        href="mailto:daraut0203@gmail.com"
                        className="btn btn-outline-light px-4 py-2"
                        style={{
                            borderRadius: "30px",
                            fontSize: "0.9rem"
                        }}
                    >
                        daraut0203@gmail.com
                    </a>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-6 mb-4 mb-md-0">
                    <h1 className="fw-bold display-5">
                        Hi, I'm <span className="text-info">Dhanashree Raut</span>
                    </h1>

                    <p className="mt-3 text-light" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                        Backend / Full Stack Developer with experience in building
                        data-driven web applications using Node.js, React, PHP, and SQL.
                    </p>

                    <div className="d-flex flex-column flex-sm-row gap-2 mt-4">
                        <a
                            href="/resume.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-light px-4"
                        >
                            View Resume
                        </a>

                        <a
                            href="https://www.linkedin.com/in/dhanashree-raut-3a763420b/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-light px-4"
                        >
                            LinkedIn
                        </a>

                        <a
                            href="https://github.com/Dhanashree-Raut"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-light px-4"
                        >
                            GitHub
                        </a>
                    </div>
                </div>


            </div>


            {/* TECH STACK */}
            <h3 className="mb-4">Tech Stack</h3>

            <div className="row mb-5 ">
                {techStack.map((tech, index) => (
                    <div key={index} className="col-md-3 col-6 mb-4">
                        <div className="card text-center p-3 h-100 tech-card ">
                            <img
                                src={tech.img}
                                alt={tech.name}
                                className="mx-auto mb-2"
                                style={{ width: "48px", height: "48px", objectFit: "contain" }}
                            />
                            <h6 className="mb-0">{tech.name}</h6>
                        </div>
                    </div>
                ))}
            </div>


            {/* EXPERIENCE PREVIEW */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Experience</h3>
                <NavLink to="/experience" className="btn btn-outline-light btn-sm text-white text-decoration-none">
                    More
                </NavLink>
            </div>

            <div ref={expRef} className="scroll-hidden  card p-3 mb-5">
                <h5>Software Enginner</h5>
                <ul className="mb-0  ps-3">
                    <li>Developed and maintained backend automation workflows and REST APIs using PHP and JavaScript.</li>
                    <li>Implemented role-based access control and secure user workflows for dynamic applications.</li>
                    <li>Collaborated closely with frontend developers, designers, and team members to deliver features end-to-end.</li>
                    <li>Participated in requirement discussions, understanding client needs and translating them into backend logic.</li>
                    <li>Worked on deployment support, bug fixing, and post-deployment issue resolution.</li>
                    <li>Improved performance and data handling through backend validation and optimized queries.</li>
                    <li>Actively involved in code reviews, learning best practices, and team knowledge sharing.</li>
                </ul>
            </div>

            {/* PROJECT PREVIEW */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Projects</h3>
                <NavLink to="/projects" className="btn btn-outline-light btn-sm text-white text-decoration-none"> More </NavLink>
            </div>

            <div ref={projectRef} className="row mb-5 scroll-hidden">
                {projects.map((project, index) => (
                    <div key={index} className="col-md-4 mb-3">
                        <div className="card p-3 h-100">
                            <h5>{project.title}</h5>
                            <p className="">{project.desc}</p>
                            {project.tech && (
                                <div className="mb-2">
                                    <div className="d-flex flex-wrap gap-1">
                                        {project.tech.map((tech, i) => (
                                            <span key={i} className="badge bg-dark">
                                                {tech}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className="d-flex gap-2">
                                {project.demo ? <a rel="noopener noreferrer" target="_blank" className="btn btn-light btn-sm" href={project.demo}>Demo</a> : ''}
                                {project.github ? <a rel="noopener noreferrer" target="_blank" className="btn btn-light btn-sm" href={project.github}>Github</a> : ''}
                            </div>

                        </div>
                    </div>
                ))}
            </div>




        </div>
    );
}
